import Image from 'next/image';
import React from 'react';

const IconWrap = ({ children }) => (
  <span className="mt-0.5 inline-flex h-8 w-8 items-center justify-center rounded-lg bg-[#E6EEFF] text-[#1A5AFF]">
    {children}
  </span>
);

const Row = ({ icon, label, text }) => (
  <li className="flex items-start gap-3">
    <IconWrap>{icon}</IconWrap>
    <div>
      <div className="text-[#112140] text-[15px] font-semibold leading-6">{label}</div>
      <div className="text-[#475467] text-[15px] leading-6">{text}</div>
    </div>
  </li>
);

const CaseStudiesSection = () => {
  return (
    <section className="max-w-[1300px] mx-auto px-4 lg:px-0 py-16 md:py-24">
      {/* Top row: text left, image right */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center mb-20">
        <div>
          <div className="mb-4 flex items-center gap-2">
            <span className="inline-flex px-3 py-1 rounded-full bg-[#E6EEFF] text-[#1A5AFF] text-[13px] font-medium">Case Study</span>
            <span className="inline-flex px-3 py-1 rounded-full bg-[#E9F7EF] text-[#147D64] text-[13px]">Liquor/Alcohol</span>
          </div>
          <h3 className="text-[28px] md:text-[32px] font-extrabold text-[#112140]">From Challenge to Success</h3>
          <ul className="mt-6 space-y-5">
            <Row
              label="Challenge"
              text="A liquor brand needed premium labels resistant to moisture."
              icon={
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 10v10m0 0-4-4m4 4 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              }
            />
            <Row
              label="Solution"
              text="Metallized film substrate + cold foiling + moisture barrier coating."
              icon={
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 6v12m6-6H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              }
            />
            <Row
              label="Result"
              text="Increased shelf life & enhanced premium brand perception."
              icon={
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="m5 13 4 4L19 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              }
            />
          </ul>
          <a href="#" className="mt-6 inline-flex items-center text-[#1A5AFF] font-semibold text-[15px]">
            Know More
            <svg className="ml-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.16675 10H15.8334M15.8334 10L10.8334 5M15.8334 10L10.8334 15" stroke="#1A5AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>
        <div className="relative w-full h-[240px] md:h-[320px] rounded-2xl overflow-hidden shadow-[0px_8px_16px_rgba(17,33,64,0.12)] border border-[#E4E7EC]">
          <Image src="/images/warehouse-labels-portfolio.png" alt="Industrial scale label manufacturing warehouse facility" fill className="object-cover" />
        </div>
      </div>

      {/* Bottom row: image left, text right */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div className="relative w-full h-[240px] md:h-[300px] rounded-2xl overflow-hidden shadow-[0px_8px_16px_rgba(17,33,64,0.12)] border border-[#E4E7EC]">
          <Image src="/images/dairy.png" alt="FMCG – Dairy Brand" fill className="object-cover" />
        </div>
        <div>
          <div className="mb-4 flex items-center gap-2">
            <span className="inline-flex px-3 py-1 rounded-full bg-[#E6EEFF] text-[#1A5AFF] text-[13px] font-medium">Case Study</span>
            <span className="inline-flex px-3 py-1 rounded-full bg-[#E9F7EF] text-[#147D64] text-[13px]">FMCG</span>
          </div>
          <h3 className="text-[24px] md:text-[28px] font-extrabold text-[#112140]">FMCG – Dairy Brand</h3>
          <p className="mt-3 text-[15px] md:text-[16px] leading-7 text-[#2F3A4A]">
            A leading dairy company faced the challenge of keeping their product labels intact under refrigeration. Frequent handling and cold-chain storage often caused traditional labels to peel or fade, risking both compliance and brand image. To solve this, we engineered self-adhesive labels using a polypropylene (PP) substrate paired with a cold-resistant adhesive. A high-gloss lamination was added to ensure long-lasting clarity and durability. The result was a reliable label solution that maintained adhesion and vibrancy in chilled conditions.
          </p>
          <a href="#" className="mt-6 inline-flex items-center text-[#1A5AFF] font-semibold text-[15px]">
            View Our Work
            <svg className="ml-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.16675 10H15.8334M15.8334 10L10.8334 5M15.8334 10L10.8334 15" stroke="#1A5AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesSection;
